import { createSelector } from '@reduxjs/toolkit';

import { getFirstSelectedItemIdentifierOrNull } from '../../library/selection/selectors';
import { RootState } from '..';
import { getPickingObjectInfo } from './pickingSelectors';

export type SnappingUnderlayTakeoverMode = 'picking-scale' | 'picking-origin' | null;

export const getSnappingUnderlayTakeoverMode = createSelector(
  (state: RootState) => state.snappingUnderlay.scalePicking?.underlayGuid,
  getFirstSelectedItemIdentifierOrNull,
  getPickingObjectInfo,
  (scalePickingUnderlayGuid, selectedItem, pickingObjectInfo): SnappingUnderlayTakeoverMode => {
    if (
      scalePickingUnderlayGuid &&
      selectedItem?.type === 'snappingUnderlay' &&
      scalePickingUnderlayGuid === selectedItem.guid
    )
      return 'picking-scale';

    if (pickingObjectInfo?.type === 'pickingLayoutPoint' && pickingObjectInfo.target === 'uploaded-lines-origin')
      return 'picking-origin';

    return null;
  },
);
